import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Alert, AlertDescription, AlertTitle } from '~/components/ui/alert';

import { ExperimentSplitMode } from '../../types/experiment.types';

interface Props {
  /** Read straight from `experiment.splitMode`. Banner only renders for `RANDOM_FALLBACK`. */
  splitMode: ExperimentSplitMode | null;
}

/**
 * Caveat banner shown when ContentScoringWorkflow couldn't get analytics
 * ad-performance for the candidate set (brand-new tenant, ad-account ingestion
 * lag, ID drift) and fell back to a round-robin Control/Test assignment.
 * Without this signal the operator would silently over-trust the lift numbers
 * — random arms aren't baseline-matched, so noise is higher and significance
 * takes longer. Null / `SCORED` renders nothing.
 */
export function RandomFallbackBanner({ splitMode }: Props) {
  const { t } = useTranslation('experiments');
  if (splitMode !== ExperimentSplitMode.RANDOM_FALLBACK) return null;
  return (
    <Alert className="border-amber-300 bg-amber-50 text-amber-900 [&>svg]:text-amber-700">
      <AlertTriangle className="h-4 w-4" aria-hidden />
      <AlertTitle>{t('detail.randomFallback.title')}</AlertTitle>
      <AlertDescription className="text-amber-900/90">
        {t('detail.randomFallback.description')}
      </AlertDescription>
    </Alert>
  );
}
